import React from "react";
import { IconWhatsapp } from "../../icon/Whatsapp";
import "./Button.css";
import "../../icon/IconSize24px.css";

export type ButtonVariant = "benefit" | "hero" | "primary" | "whatsapp";

interface ButtonProps {
  variant: ButtonVariant;
  label: string;
  href?: string;
  onClick?: () => void;
}

/**
 * A unified Button component that supports multiple variants:
 * - benefit: Displays a benefit-styled button
 * - hero: A hero section button with link
 * - primary: Primary action button with link
 * - whatsapp: WhatsApp contact button with icon
 */
export const Button: React.FC<ButtonProps> = ({ 
  variant, 
  label, 
  href, 
  onClick 
}) => {
  const className = `button button-${variant}`;
  
  // Benefit variant is a div, others are anchor tags
  if (variant === "benefit") {
    return (
      <div className={className} onClick={onClick}>
        <span className="navigated-text-bold">{label}</span>
      </div>
    );
  }

  // Whatsapp variant includes an icon
  if (variant === "whatsapp") {
    return (
      <a className={className} href={href} onClick={onClick}>
        <IconWhatsapp className="icon-size-24px" />
        <span className="navigated-text-bold">{label}</span>
      </a>
    );
  }

  // Hero and Primary variants are simple anchor tags
  return (
    <a className={className} href={href} onClick={onClick}>
      <span className="navigated-text-bold">{label}</span>
    </a>
  );
};
